// extracted by mini-css-extract-plugin
export default {"block":"CopyBlock_block__Lv52x","trash":"CopyBlock_trash__vs3oJ"};